import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function ComingSoon() {
  const location = useLocation();
  const page = location.pathname.replace('/', '').replace(/-/g, ' ');

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '2rem',
      color: '#e0e0e0'
    }}>
      <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚧</div>
      <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem', textTransform: 'capitalize' }}>
        {page || 'Sayfa'}
      </h1>
      <p style={{ color: '#aaa', marginBottom: '2rem' }}>
        Bu sayfa yakında hizmetinize sunulacaktır.
      </p>
      <Link
        to="/dashboard"
        style={{
          backgroundColor: '#f0b429',
          color: '#000',
          padding: '0.75rem 1.5rem',
          borderRadius: '8px',
          textDecoration: 'none',
          fontWeight: 'bold'
        }}
      >
        📊 Dashboard'a Dön
      </Link>
    </div>
  );
}

export default ComingSoon;
